export default __webpack_public_path__ + "static/paul-1fc294596db956297d45b1ed3c2472f3.svg";